<template>
  <BreadCrumb PageTitle="Modifier les Bills of Lading (BL) - Étape 2" />
  <EditAddBescStep2/>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditAddBescStep2 from "@/components/BESC/EditBesc/EditAddBescStep2.vue";

export default defineComponent({
  name: "EditAddBescStep2Page",
  components: {
    BreadCrumb,
    EditAddBescStep2,
  },
});
</script>